var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leading-link",style:(_vm.leadingLinkSizeStyle()),on:{"click":function($event){return _vm.goTo(_vm.to)}}},[_c('span',[_vm._t("default"),_c('div',{staticClass:"leading-arrow",style:(_vm.leadingArrowSizeStyle())})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }